import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const GamesSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$gamesSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$gamesSection' });

  return (
    <section id="hp-games" className="hp-section games-section games">
      <div
        className="hp-banner desktop-only"
        data-event-name="bloc_interact"
        data-bloc-name={t('title')}
      >
        <Link href={tLink('games')} className="clearfix">
          <div className="ctg-image">
            <picture>
              <source
                data-srcset="/images/homepage/gamesSection/LEM-Games-mob.jpg"
                media="(max-width: 768px)"
                srcSet="/images/homepage/gamesSection/LEM-Games-mob.jpg"
              />
              <img
                data-src="/images/homepage/gamesSection/LEM-Games.jpg"
                alt={t('alt')}
                src="/images/homepage/gamesSection/LEM-Games.jpg"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                width="960"
                height="750"
              />
            </picture>
          </div>
          <div className="stack color-bg">
            <h2>{t('title')}</h2>
            <p className="desktop-only">{t('copy')}</p>
            <span className="btn base-btn btn-main white">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default GamesSection;
